(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial"] && !Shopify.designMode) return;
  try {
    
  function sbInitReviews(root) {
    var track = root.querySelector('.sb-adv__reviews-track');
    if (!track || root.dataset.sbBound) return;
    root.dataset.sbBound = '1';
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dots = root.querySelectorAll('[data-dot]');
    var cards = root.querySelectorAll('.sb-adv__review');
    function step() {
      if (cards.length > 1) { return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left; }
      return track.clientWidth;
    }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
    });
    function update() {
      var idx = Math.round(track.scrollLeft / step());
      if (idx < 0) { idx = 0; }
      if (idx > dots.length - 1) { idx = dots.length - 1; }
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    update();
  }
  function sbInitAll(scope) {
    (scope || document).querySelectorAll('.sb-adv__reviews').forEach(sbInitReviews);
  }
  document.addEventListener('DOMContentLoaded', function () { sbInitAll(document); });
  document.addEventListener('shopify:section:load', function (e) { sbInitAll(e.target); });

  } catch(e) { console.error(e); }
})();
})();
